export default __webpack_public_path__ + "static/media/logo__opacity.c7669197.png";